module.exports = __webpack_public_path__ + "img/rapid-vienne.04b2104a.png";